module.exports = __webpack_public_path__ + "static/media/hodiny2.c662c93d.jpg";